import axios from 'axios'
import * as localData from '@/services/localData.js'
import Vue from 'vue'
import { login } from "@/services/api";


const state = () => ({
  status: '',
  auth_token: localData.getlocalToken('auth_token') || '',
  name : localData.getlocalToken('name') || '',
  roles: JSON.parse(localData.getlocalToken('roles')) || '',
})

const mutations = {
  auth_request(state){
    state.status = 'loading'
  },
  auth_success(state, data){
    state.status = 'success'
    state.auth_token = data.auth_token
    state.name = data.name
    state.roles = data.roles
  },
  auth_error(state){
    state.status = 'error'
  },
  logout(state){
    state.status = ''
    state.auth_token = ''
    state.perfil = ''
  },
  auth_validate(state, auth_token){
    state.status = 'success'
    state.auth_token = auth_token
  }
}

const actions = {
  async authenticate({ commit }, user) {
    try {
      //const {success} = await login(user)
      if(user.username == 'linasa_user'){
        var data = {
          auth_token : '23425436fgdfdgfdg',
          name : user.username,
          roles : ['cargador']
        }

        localData.setlocalToken('auth_token',data.auth_token)
        localData.setlocal('name',data.name)
        localData.setlocal('roles',JSON.stringify(data.roles))
        commit('auth_success',data)
      }else if (user.username == 'blazquez_user'){
        var data = {
          auth_token : '23425436fgdfdgfdg',
          name : user.username,
          roles : ['transitario']
        }

        localData.setlocalToken('auth_token',data.auth_token)
        localData.setlocal('name',data.name)
        localData.setlocal('roles',JSON.stringify(data.roles))
        commit('auth_success',data)
      } else {
        Vue.noty.error("El usuario o la contraseña no son correctos.")
        commit('auth_error')
      }
      //transportista -> olc_user



      // if(success == true){
        
      //   //Test data///
      //   const data = {
      //     auth_token : 'Token',
      //     name : user.username,
      //     roles : ['cargador','transitario']
      //   }
      //   localData.setlocalToken('auth_token',data.auth_token)
      //   localData.setlocal('name',data.name)
      //   localData.setlocal('roles',JSON.stringify(data.perfil))
      //   commit('auth_success',data)
      // } else{
      //   commit('auth_error')
      // }
      // commit('auth_success',data)
    } catch (e) {
      commit('auth_error')
    }
  },
  logout({commit}){
    return new Promise((resolve, reject) => {
      commit('logout')
      localData.deletelocalToken('auth_token')
     // Vue.noty.success("Goodbye")
     // Vue.router.push('/')
      resolve('OK')
    })
  }
}

 const getters = {
    isLoggedIn: state => !!state.auth_token,
    authStatus: state => state.authStatus,
    token: state => state.token,
    name: state => state.name,
    roles: state => state.roles,
    authorized: state => rol => !!state.roles.find(userRol => userRol === rol)
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }